const RootPath = window.g.baseUrl;
const apis = {
    getproductundertakeList: RootPath + 'plugin/product/default/GetproductundertakeList',
    delProductUnderTakes: RootPath + 'plugin/product/default/DelProductUnderTakes',
    delProductUnderTake: RootPath + 'plugin/product/default/DelProductUnderTake',
    insertProductExcelData: RootPath + 'plugin/product/default/InsertProductExcelData'
};

export default apis;
